const LaosSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111735)">
      <path
        d="M38.0153 11.3044C34.7803 4.61445 27.9291 0 19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044L19.9998 13.0435L38.0153 11.3044Z"
        fill="#D80027"
      />
      <path
        d="M1.98438 28.6962C5.21938 35.3861 12.0706 40.0005 19.9998 40.0005C27.9291 40.0005 34.7803 35.3861 38.0153 28.6962L19.9998 26.957L1.98438 28.6962Z"
        fill="#D80027"
      />
      <path
        d="M38.0155 11.3047H1.98453C0.713125 13.934 0 16.8838 0 20.0003C0 23.1168 0.713125 26.0666 1.98453 28.6959H38.0154C39.287 26.0666 40 23.1168 40 20.0003C40 16.8838 39.287 13.934 38.0155 11.3047Z"
        fill="#0052B4"
      />
      <path
        d="M19.9999 26.9559C23.8419 26.9559 26.9564 23.8414 26.9564 19.9995C26.9564 16.1575 23.8419 13.043 19.9999 13.043C16.158 13.043 13.0435 16.1575 13.0435 19.9995C13.0435 23.8414 16.158 26.9559 19.9999 26.9559Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111735">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default LaosSvg;
